/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    instanceOfQaEquipmentSubCategory,
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';

/**
 * @type EquipmentTypeCatalogDtoSubCategory
 * 
 * @export
 */
export type EquipmentTypeCatalogDtoSubCategory = QaEquipmentSubCategory;


export function EquipmentTypeCatalogDtoSubCategoryFromJSON(json: any): EquipmentTypeCatalogDtoSubCategory {
    return EquipmentTypeCatalogDtoSubCategoryFromJSONTyped(json, false);
}

export function EquipmentTypeCatalogDtoSubCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentTypeCatalogDtoSubCategory {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...QaEquipmentSubCategoryFromJSONTyped(json, true) };
    return  QaEquipmentSubCategoryFromJSONTyped(json, true);
}

export function EquipmentTypeCatalogDtoSubCategoryToJSON(value?: EquipmentTypeCatalogDtoSubCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfQaEquipmentSubCategory(value)) {
        return QaEquipmentSubCategoryToJSON(value as QaEquipmentSubCategory);
    }

    return {};
}

/**
 * Check if a given object implements the EquipmentTypeCatalogDtoSubCategory interface.
 */
export function instanceOfEquipmentTypeCatalogDtoSubCategory(value: any): value is EquipmentTypeCatalogDtoSubCategory {
    if (instanceOfQaEquipmentSubCategory(value)) return true;
    return false;
}

